import React from 'react';
export function Process() {
  return <section className="py-[80px] px-6 md:py-[120px] md:px-[72px] bg-surface border-y border-[#1a1a1a]" id="proceso" data-id="element-89">
      <div className="max-w-[1200px] mx-auto" data-id="element-90">
        <div className="inline-flex items-center gap-2.5 text-[10px] tracking-[3px] uppercase text-gold mb-5 font-medium" data-id="element-91">
          <span className="w-6 h-px bg-gold" data-id="element-92"></span>
          El Proceso
        </div>

        <h2 className="font-serif text-[clamp(38px,4vw,62px)] font-light leading-[1.08] tracking-tight mb-5 text-cream" data-id="element-93">
          Tu sistema de crecimiento,
          <br data-id="element-94" />
          construido en <em className="italic text-gold-bright" data-id="element-95">3 fases.</em>
        </h2>

        <p className="text-[17px] text-muted max-w-[520px] leading-relaxed" data-id="element-96">
          No solo corremos anuncios. Construimos el motor completo que convierte
          desconocidos en clientes pagantes de reparación de crédito.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 mt-[70px] border border-subdued" data-id="element-97">
          <div className="p-10 md:py-[52px] md:px-11 border-b md:border-b-0 md:border-r border-subdued relative overflow-hidden transition-colors duration-300 hover:bg-[rgba(184,151,58,0.03)] group" data-id="element-98">
            <div className="absolute top-0 left-0 right-0 h-[2px] bg-gold origin-left scale-x-0 transition-transform duration-400 ease-in-out group-hover:scale-x-100" data-id="element-99" />
            <div className="font-serif text-[72px] font-light text-[rgba(184,151,58,0.12)] leading-none mb-6 tracking-[-2px]" data-id="element-100">
              01
            </div>
            <h3 className="font-serif text-2xl font-semibold mb-3.5 leading-[1.25] text-cream" data-id="element-101">
              Auditoría y Estrategia
            </h3>
            <p className="text-sm text-muted leading-relaxed" data-id="element-102">
              Analizamos tu proceso actual, identificamos los puntos de fuga y
              construimos un roadmap personalizado. Sin plantillas genéricas —
              esto es específico para tu negocio.
            </p>
          </div>

          <div className="p-10 md:py-[52px] md:px-11 border-b md:border-b-0 md:border-r border-subdued relative overflow-hidden transition-colors duration-300 hover:bg-[rgba(184,151,58,0.03)] group" data-id="element-103">
            <div className="absolute top-0 left-0 right-0 h-[2px] bg-gold origin-left scale-x-0 transition-transform duration-400 ease-in-out group-hover:scale-x-100" data-id="element-104" />
            <div className="font-serif text-[72px] font-light text-[rgba(184,151,58,0.12)] leading-none mb-6 tracking-[-2px]" data-id="element-105">
              02
            </div>
            <h3 className="font-serif text-2xl font-semibold mb-3.5 leading-[1.25] text-cream" data-id="element-106">
              Lanzamiento de tu Máquina de Leads
            </h3>
            <p className="text-sm text-muted leading-relaxed" data-id="element-107">
              Lanzamos campañas de Meta Ads para el nicho de reparación de
              crédito, conectadas a GoHighLevel con automatización de
              seguimiento que trabaja 24/7.
            </p>
          </div>

          <div className="p-10 md:py-[52px] md:px-11 relative overflow-hidden transition-colors duration-300 hover:bg-[rgba(184,151,58,0.03)] group" data-id="element-108">
            <div className="absolute top-0 left-0 right-0 h-[2px] bg-gold origin-left scale-x-0 transition-transform duration-400 ease-in-out group-hover:scale-x-100" data-id="element-109" />
            <div className="font-serif text-[72px] font-light text-[rgba(184,151,58,0.12)] leading-none mb-6 tracking-[-2px]" data-id="element-110">
              03
            </div>
            <h3 className="font-serif text-2xl font-semibold mb-3.5 leading-[1.25] text-cream" data-id="element-111">
              Optimización y Escala
            </h3>
            <p className="text-sm text-muted leading-relaxed" data-id="element-112">
              Análisis semanal, pruebas continuas de creativos y optimización
              constante. Escalamos lo que funciona, eliminamos lo que no. Tú ves
              los números, siempre.
            </p>
          </div>
        </div>
      </div>
    </section>;
}